var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVkontakte = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 12,
  viewBox: "0 0 21 12"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 .019h21V12H0"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  id: "$",
  fill: "#CACACA",
  d: "M11.517 11.995c.532 0 .75-.355.744-.8-.027-1.673.625-2.573 1.801-1.399 1.303 1.3 1.572 2.199 3.153 2.199h2.8c2.203 0 .24-2.206-1.312-3.643-1.476-1.366-1.545-1.398-.274-3.043C20.006 3.27 22.068.64 20.244.64H16.76c-.676 0-.725.394-.965.96-.87 2.047-2.525 4.701-3.153 4.296-.658-.424-.357-1.862-.306-4.354.013-.658.01-1.11-.999-1.343C8.584-.44 6.2.814 7.173.995c1.375.256 1.243 2.985.922 4.266-.558 2.23-2.656-1.767-3.53-3.758C4.353 1.024 4.29.64 3.535.64H.688C.139.64-.13.89.062 1.4c.191.508 2.395 5.426 5 8.232 2.412 2.597 4.796 2.364 6.455 2.364"
}))));
export default SvgVkontakte;